import React from "react";
import { Link, NavLink } from "react-router-dom";
import { Menu, X } from "lucide-react";
import { BRAND } from "../lib/brand";

const NAV = [
  { to: "/", label: "Home" },
  { to: "/about", label: "About Us" },
  { to: "/products", label: "Products" },
  { to: "/infrastructure", label: "Infrastructure" },
  { to: "/contact", label: "Contact" },
];

export default function Navbar({ onGetQuote }) {
  const [open, setOpen] = React.useState(false);

  return (
    <header
      data-testid="site-header"
      className="sticky top-0 z-40 backdrop-blur-xl bg-white/80 border-b border-black/5"
    >
      <div className="mx-auto max-w-7xl px-6 sm:px-8">
        <div className="flex h-20 items-center justify-between">
          <Link
            to="/"
            data-testid="nav-logo-link"
            className="flex items-center gap-3"
            onClick={() => setOpen(false)}
          >
            <div className="h-12 w-12 flex items-center justify-center overflow-hidden">
              <img
                src={BRAND.logoUrl}
                alt="Sylva King Plywood"
                className="h-12 w-12 object-contain"
                data-testid="nav-logo-img"
              />
            </div>
            <div className="leading-tight hidden sm:block">
              <div className="font-serif text-xl text-wood-800 tracking-tight">
                Sylva King
              </div>
              <div className="text-xs uppercase tracking-[0.3em] text-gold-600 font-bold">
                  Plywood
                </div>
            </div>
          </Link>

          <nav className="hidden lg:flex items-center gap-8">
            {NAV.map((n) => (
              <NavLink
                key={n.to}
                to={n.to}
                end={n.to === "/"}
                data-testid={`nav-link-${n.label.toLowerCase().replace(/\s/g, "-")}`}
                className={({ isActive }) =>
                  `gold-underline text-sm font-medium ${
                    isActive ? "text-gold-600" : "text-wood-800 hover:text-gold-600"
                  }`
                }
              >
                {n.label}
              </NavLink>
            ))}
          </nav>

          <div className="flex items-center gap-3">
            <button
              data-testid="nav-get-quote-btn"
              onClick={onGetQuote}
              className="btn-primary hidden sm:inline-flex items-center px-5 py-2.5 text-sm font-semibold"
            >
              Get a Quote
            </button>
            <button
              data-testid="nav-mobile-toggle"
              className="lg:hidden p-2 text-wood-800"
              onClick={() => setOpen((v) => !v)}
              aria-label="Toggle menu"
            >
              {open ? <X size={22} /> : <Menu size={22} />}
            </button>
          </div>
        </div>

        {open && (
          <div className="lg:hidden pb-6 pt-2 border-t border-wood-200" data-testid="mobile-menu">
            <nav className="flex flex-col gap-1">
              {NAV.map((n) => (
                <NavLink
                  key={n.to}
                  to={n.to}
                  end={n.to === "/"}
                  onClick={() => setOpen(false)}
                  data-testid={`mobile-nav-link-${n.label.toLowerCase().replace(/\s/g, "-")}`}
                  className={({ isActive }) =>
                    `py-3 text-base ${
                      isActive ? "text-gold-600" : "text-wood-800"
                    }`
                  }
                >
                  {n.label}
                </NavLink>
              ))}
              <button
                data-testid="mobile-get-quote-btn"
                onClick={() => {
                  setOpen(false);
                  onGetQuote?.();
                }}
                className="btn-primary mt-3 inline-flex w-full justify-center px-5 py-3 text-sm font-semibold"
              >
                Get a Quote
              </button>
            </nav>
          </div>
        )}
      </div>
    </header>
  );
}
